import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=622acb4a&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=622acb4a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622acb4a",
  null
  
)

export default component.exports